import { usePageStore } from '@/Components/templates/PageStore';
import ClearIcon from '@mui/icons-material/Clear';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Stack } from '@mui/material';
import { useEffect } from 'react';

type SettingsActionBarProps = {
  onSave?: () => void;
  loading?: boolean;
  canSave?: boolean;
  onReset?: () => void;
};

export const SettingsActionBar = (props: SettingsActionBarProps) => {
  const pageLoading = usePageStore((state) => state.pageLoading);

  useEffect(() => {
    if (props?.loading === true && pageLoading === false) usePageStore.setState({ pageLoading: true });
    if (props?.loading === false && pageLoading === true) usePageStore.setState({ pageLoading: false });
  }, [props?.loading]);

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ py: 1, px: 4, borderBottom: '1px solid #e3e3e3' }}
      justifyContent="flex-end"
    >
      {/* reset button when available */}
      {props?.onReset && props?.canSave && (
        <Button className="z-btn-3" startIcon={<ClearIcon />} onClick={props?.onReset}>
          Reset
        </Button>
      )}

      <LoadingButton
        className="z-btn-3"
        startIcon={<SaveIcon />}
        loading={props?.loading}
        onClick={props?.onSave}
        disabled={props?.canSave === false}
      >
        Save
      </LoadingButton>
    </Stack>
  );
};

export default SettingsActionBar;
